<template>
  <!-- <div style='position: absolute z-index: 100000' class="bg-red">
    <v-chip color="green">{{layer.id}}</v-chip><br>
    <v-chip color="green">{{layer.title}}</v-chip><br>
    <v-chip color="green">{{layer.source_type}}</v-chip><br>
      <v-chip color="green">{{layer.title}}</v-chip><br>
      <v-chip color="green">{{layer.label}}</v-chip><br>
  </div> -->

  <ol-tile-layer v-if="layer.visible" :zIndex="2">

    <template>
      <ol-source-xyz :url="props.layer.url" :projection="layer.projection" crossOrigin="anonymous" />
    </template>

    <!-- <template v-if="layer.source_type == 'xyz'">
      <ol-source-xyz :url="layer.url + '/{z}/{x}/{y}.jpg'" :projection="layer.projection" crossOrigin="anonymous" />
    </template> -->

    <!-- <template v-if="layer.source_type == 'tms'">
      <ol-source-xyz :tileUrlFunction="tileUrl" :projection="layer.projection" crossOrigin="anonymous" />
    </template> -->
<!-- 
    <template v-if="layer.source_type == 'tms'">
      <ol-source-xyz :url="url"  :projection="layer.projection" crossOrigin="anonymous" />
    </template> -->


  </ol-tile-layer>
</template>

<script setup>

import { onMounted, onUnmounted } from 'vue'

const props = defineProps(['layer', ])


// const url = `${baseURL}{z}/{x}/{-y}.jpg`

// function tileUrl(tileCoord, resolution, projection) {

//   const zoom = tileCoord[0] // Zoom level
//   const x = tileCoord[1]    // Tile X index

//   const numTiles = Math.pow(2, zoom) // Total tiles at this zoom level
//   const y = numTiles - 1 - tileCoord[2]

//   return `${baseURL}${zoom}/${x}/${y}.jpg`
// }



onMounted(() => {
  console.log("🧩 " + props?.layer?.id + " mounted")
})

onUnmounted(() => {
  console.log("🧩 " + props?.layer?.id + " unmounted")
})

</script>
